import * as Period from 'constants/Period';

const VOLLEYBALL_PERIOD_MAP = {};
VOLLEYBALL_PERIOD_MAP[400] = Period.NOT_STARTED;
VOLLEYBALL_PERIOD_MAP[401] = Period.FIRST;
VOLLEYBALL_PERIOD_MAP[402] = Period.SECOND;
VOLLEYBALL_PERIOD_MAP[403] = Period.THIRD;
VOLLEYBALL_PERIOD_MAP[404] = Period.FOURTH;
VOLLEYBALL_PERIOD_MAP[405] = Period.FIFTH;
VOLLEYBALL_PERIOD_MAP[406] = Period.FINISHED;
VOLLEYBALL_PERIOD_MAP[407] = Period.SIXTH;

export default VOLLEYBALL_PERIOD_MAP;



// WEBPACK FOOTER //
// ./js/sport-betting/components/grid-control/sportGlossary/Volleyball/PeriodMap.js